import * as React from 'react';
import './ReceiveCoupons.less'

interface IReceiveCouponsPropsType {
    prefixCls?: string;
    onHandleClick?: () => void;
    data?: any;
}

// 领券满减组件
const FullReduction = (props: any): JSX.Element => {
    return (
        <div className={`${props.prefixCls}-reductionBox`}>
            {
                props.data.couponsTwo.map((item: any, index: number) => {
                    return (
                        <div className={`${props.prefixCls}-reduction`} key={index}>
                            {item}
                            <span />
                            <span />
                        </div>
                    )
                })
            }
            <span className={`${props.prefixCls}-ellipsis`}>...</span>
        </div>
    )
};

/**
 * 商详界面领券组件
 * @class ReceiveCoupons
 * @extends {React.Component}
 */
class ReceiveCoupons extends React.Component<IReceiveCouponsPropsType, any> {
    static defaultProps = {
        prefixCls: 'receive-couponsComp'
    };

    render() {
        const {prefixCls, onHandleClick, data} = this.props;
        return (
            <div className={`${prefixCls}`} onClick={onHandleClick}>
                <div className={`${prefixCls}-border-bottom`}>
                    <span className={`${prefixCls}-msg`}>领券</span>
                        {data.couponsTwo && <FullReduction {...this.props}/>}
                    <div className={`${prefixCls}-more`} />
                </div> 
            </div>
        )
    }
}

export default ReceiveCoupons


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/receiveCoupons/ReceiveCoupons.tsx